import React from 'react';
import type { AnimationSettingsDefinition } from '@/components/AnimationSetting';
import AnimationSettings from '@/components/AnimationSetting';
import type { ContentfulComponentDefinition } from '@/components/ContentfulComponent/ContentfulComponentDefinition';
import type { LinkDefinition } from '@/components/ContentfulComponent/Link';
import SmartLink from '@/components/SmartLink';
import GreenArrowIcon from './GreenArrowIcon';

export type FullImageTextAnimationDefinition = ContentfulComponentDefinition & {
  text: string,
  backgroundColor: {
    value: string,
  },
  fontColor: {
    value: string,
  },
  animationSettings: AnimationSettingsDefinition,
  link: LinkDefinition,
  internal: {
    type: 'ContentfulSubComponentFullImageTextAnimation'
  }
};

export type FullImageCardProps = {
  content: FullImageTextAnimationDefinition;
  isHovering: boolean;
};

const FullImageTextAnimation = ({ content, isHovering }: FullImageCardProps) => {
  const {
    text,
    backgroundColor,
    fontColor,
    animationSettings,
    link,
  } = content;

  return (
    <AnimationSettings content={animationSettings} active={isHovering}>
      <SmartLink
        href={link.href}
        slug={link.page?.slug}
        className="no-underline"
      >
        <div
          className={`
            absolute bottom-0 left-0 right-0 z-20
            flex items-center justify-center gap-2
            transition-all duration-300
            overflow-hidden
            ${isHovering ? 'opacity-100 h-[60px] pointer-events-auto' : 'opacity-0 h-0 pointer-events-none'}
          `}
          style={{
            backgroundColor: backgroundColor.value || 'rgba(0, 0, 0, 0.7)',
            color: fontColor.value || '#fff',
          }}
        >
          <GreenArrowIcon />
          <span className="text-white text-base font-poppins-semi-bold">{text}</span>
        </div>
      </SmartLink>
    </AnimationSettings>
  );
};

export default FullImageTextAnimation;
